const docsURL = "https://docs.devprod.prod.corp.mongodb.com/parsley";

export { docsURL };
